import React from 'react'
import { bool, string, oneOfType, arrayOf, node } from 'prop-types'

class SchemaTag extends React.Component {
  render () {
    const { noSchemaMarkup, tagType, children } = this.props

    let stuffToRender = null

    const CustomTag = `${tagType}`

    let newProps = {}
    const excludeProps = [ 'noSchemaMarkup', 'tagType', 'children' ]

    Object.keys(this.props).map((prop) => {
      if (excludeProps.indexOf(prop) === -1 && (!noSchemaMarkup || prop.length < 4 || prop.substring(0, 4) !== 'item')) {
        newProps[ prop ] = this.props[ prop ]
      }
      return prop
    })

    if (children !== null) {
      stuffToRender = <CustomTag {...newProps}>{ children }</CustomTag>
    } else {
      stuffToRender = <CustomTag {...newProps} />
    }

    return (stuffToRender)
  }
}

SchemaTag.propTypes = {
  noSchemaMarkup: bool,
  tagType: string,
  children: oneOfType([arrayOf(node), node])
}

SchemaTag.defaultProps = {
  noSchemaMarkup: false,
  tagType: 'span',
  children: null
}

export default SchemaTag



// WEBPACK FOOTER //
// ./shared/_layouts/_templates/_includes/SchemaTag.jsx